import { MdLink } from "react-icons/md";
import FILE_ICON from "shared/assets/images/file_icon.png";
import Loading from "shared/components/Spin";

const Attachments = ({ loading, unlinkAttachment, list, useDownloadLinks }) => {
  if (loading) return <Loading />;

  return (
    <div className="quote-template__attachments">
      {list.map(({ id, name, contentType }, index) => (
        <div
          className="quote-template__attachments--file"
          key={`attachment_${index}`}
        >
          {useDownloadLinks ? (
            <MdLink
              className="quote-template__attachments--fileIcon"
              size={20}
            />
          ) : (
            <img
              className="quote-template__attachments--fileIcon"
              src={FILE_ICON}
              alt={name}
            />
          )}
          <span className="quote-template__attachments--fileName">{name}</span>
          <span className="quote-template__attachments--fileType">
            [{useDownloadLinks ? "lien" : contentType.split("/")[1]}]
          </span>
        </div>
      ))}
    </div>
  );
};

export default Attachments;
